enum ContentFilter {
  ALL = 'all',
  FALL = '낙상방지',
  MENTAL_HEALTH = '정신건강',
  REHABILITATION = '재활',
}

export default ContentFilter;
